export function pushLogRocketSessionEvent(hook, sessionURL) {
  if (hook._logRocketHookDestroyed || !hook.liveSocket?.isConnected()) {
    return false
  }

  hook.pushEvent("logrocket-session", { url: sessionURL })
  return true
}

export const logRocketPushSessionOnMount = {
  mounted() {
    this._logRocketHookDestroyed = false
    const sessionData = document.body.dataset
    const logrocketEnabled = sessionData.logrocketEnabled
    if (logrocketEnabled == "true") {
      this.pushLogRocketSession()
    }
    window.crashLiveView = () =>
      this.pushEvent("manual-liveview-crash-requested", {})

    // Real Appcues/Intercom identity is pushed post-connect (dead render only
    // boots both SDKs anonymously) from UserLiveAuth.on_mount — the one hook
    // shared by every authenticated live_session (main app + client portal),
    // so this listener has to live on a hook mounted in every one of their
    // layouts too, not just the main app's Navbar. user_hash comes from the
    // body dataset, already computed server-side with no DB work. [ENA-9362]
    this.handleEvent("intercom_identify", async (payload) => {
      const { updateIntercom } = await import("../intercom")
      updateIntercom({
        ...payload,
        user_hash: document.body.dataset.intercomUserHash,
      })
    })

    this.handleEvent("appcues_identify", (payload) => {
      const { userId, ...traits } = payload
      if (window.Appcues) {
        window.Appcues.identify(userId, traits)
        // Page-local acknowledgement survives live navigation/reconnects,
        // but a fresh document or a different user identifies again.
        window.appcuesIdentifiedUser = userId
      }
    })
  },
  async pushLogRocketSession() {
    const module = await import("logrocket")
    let LogRocket = module.default
    LogRocket.getSessionURL(async (sessionURL) => {
      // Update Intercom with LogRocket session URL
      const { updateIntercom } = await import("../intercom")
      updateIntercom({
        custom_attributes: {
          logrocket_session_url: sessionURL,
        },
      })
      pushLogRocketSessionEvent(this, sessionURL)
    })
  },
  destroyed() {
    this._logRocketHookDestroyed = true
  },
}
